import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "star-off",
  "use": "star-off-usage",
  "viewBox": "0 0 20 19.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 19.02\" id=\"star-off\"><title>star-off</title><g id=\"star-off_Page-1\"><g id=\"star-off_solarman-v003\"><g id=\"star-off_Group-14\"><path id=\"star-off_Star-Copy-5\" d=\"M10,15.1l4.4,2-.5-4.79,3.22-3.58-4.71-1L10,3.52,7.59,7.69l-4.71,1L6.1,12.27l-.5,4.79Zm0,1.66L3.82,19.51l.7-6.73L0,7.75,6.61,6.34,10,.49l3.39,5.85L20,7.75l-4.52,5,.7,6.73Z\" transform=\"translate(0 -0.49)\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/star-off.svg
// module id = mUd6
// module chunks = 268